import '../styles.scss'
import React from 'react'

import { Text } from 'components/SmartChatView/Fields'
import ReadMoreText from 'components/common/ReadMoreText'

const TextBoxViewUI = ({ renderType, label, placeholder, value, onChangeInner, error }) => (
  <div className='action-view'>
    {renderType === 'action' && (
      <Text
        isRequired
        label={renderType === 'action' ? label : null}
        placeholder={placeholder}
        value={value}
        onChange={onChangeInner}
        error={error}
      />
    )}
    {renderType === 'preview' && (
      <div className='action-view__textbox-preview'>
        <ReadMoreText
          mode='lines'
          lines={2}
          customTextClassName='action-view__text'
        >
          {value}
        </ReadMoreText>
      </div>
    )}
  </div>
)

export default TextBoxViewUI
